import Image from "next/image";
import * as React from "react";
import { FaAngleLeft, FaQuestion } from "react-icons/fa6";
import {useContext} from "react";
import {Basket} from "../../../../context/basket";
import Grid from '@mui/material/Unstable_Grid2';
import Box from "@mui/material/Box";

const InformationCard = (props) => {
    let jsonResult = [];
    const basket = useContext(Basket);
    if (typeof props?.product?.tooltip_content !== 'undefined') {
        jsonResult = JSON.parse(props?.product?.tooltip_content);
    }

    const name = (typeof props.product.non_medical_name !== 'undefined' &&
        (!basket?.data?.logged_in || !basket?.data?.consultation)) ? props.product.non_medical_name : props.product.name;
    const height = (typeof jsonResult.height !== 'undefined') ? jsonResult.height : 350;
    const width = (typeof jsonResult.width !== 'undefined') ? jsonResult.width : 350;

    // We dangerously set html, so the HTML is taken as-is from the database and used as HTML rather than a string.
    const getDescription = () => {
        return {__html: jsonResult.description}
    }

    return <Box className="bg-lt-grey rounded padding-2">
        {typeof props?.product?.tooltip_content === 'undefined' && (
            <>
                <a onClick={() => props.flipCard()} title="Flip back">
                    <span><FaQuestion /></span>
                </a>
                <Box className="content-missing">Content Missing from database. @Sons</Box>
            </>

        )}
        {props?.product?.tooltip_content && (
            <Box>
                <Grid container>
                    <Grid xs={11}>
                        <h3 className="no-margin">{name}</h3>
                    </Grid>
                    <Grid xs={1}>
                        <Box className="hover">
                            <a className="pointer block bg-dk-grey bg-hover-primary radius-50 lt-grey padding-small-top-3 padding-small-bottom-5 padding-small-x-4" style={{width: 14, height: 14}} onClick={() => props.flipCard()} title="Flip back">
                                <span><FaAngleLeft /></span>
                            </a>
                        </Box>
                    </Grid>
                </Grid>

                    {jsonResult.description !== "" && (
                        <>
                            <h4 className="margin-bottom-0">Description</h4>
                            <h5 className="margin-top-0" dangerouslySetInnerHTML={getDescription()}/>
                        </>
                    )}

                        {jsonResult.effectiveness !== '' && (
                            <>
                                <h4 className="margin-bottom-0">Effectiveness</h4>
                                <h5 className="margin-top-0">{jsonResult.effectiveness}</h5>
                            </>
                        )}
                        {jsonResult.results !== '' && (
                            <>
                                <h4 className="margin-bottom-0">Results</h4>
                                <h5 className="margin-top-0">{jsonResult.results}</h5>
                            </>
                        )}


                {typeof jsonResult.imaee !== 'undefined' && jsonResult.image !== null && (
                    <Image className="margin-top-1" width={width} height={height} src={jsonResult.image} alt={name} priority={2}/>
                )}
            </Box>
        )}
    </Box>
}

export default InformationCard;